import { MagnifyingGlassIcon, MapPinIcon } from "@heroicons/react/24/outline";
import { useDebounce } from "@uidotdev/usehooks";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

export default function QuoteSearchFields({
  sortAdditionalBody,
  setSortAdditionalBody,
}: {
  sortAdditionalBody: Record<string, any>;
  setSortAdditionalBody: (body: Record<string, any>) => void;
}) {
  const { t } = useTranslation("leads");
  const [searchVrm  , setSearchVrm  ] = useState("");
  const [searchName , setSearchName ] = useState("");
  const [searchMake , setSearchMake ] = useState("");
  const [searchModel, setSearchModel] = useState("");
  const [searchPostcode, setSearchPostcode] = useState("");
  const [priceFrom  , setPriceFrom  ] = useState("");
  const [priceTo    , setPriceTo    ] = useState("");

  const debouncedSearchVrm      = useDebounce(searchVrm     , 500);
  const debouncedSearchName     = useDebounce(searchName    , 500);
  const debouncedSearchMake     = useDebounce(searchMake    , 500);
  const debouncedSearchModel    = useDebounce(searchModel   , 500);
  const debouncedSearchPostcode = useDebounce(searchPostcode, 500);
  const debouncedPriceFrom      = useDebounce(priceFrom     , 500);
  const debouncedPriceTo        = useDebounce(priceTo       , 500);

  useEffect(() => {
    const newBody = {
      SearchVrm      : debouncedSearchVrm      || null,
      SearchName     : debouncedSearchName     || null,
      SearchMake     : debouncedSearchMake     || null,
      SearchModel    : debouncedSearchModel    || null,
      SearchPostcode : debouncedSearchPostcode || null,
      PriceFrom      : debouncedPriceFrom ? parseFloat(debouncedPriceFrom) : null,
      PriceTo        : debouncedPriceTo   ? parseFloat(debouncedPriceTo)   : null,
    };
    setSortAdditionalBody(newBody);
  }, [debouncedSearchVrm, debouncedSearchName, debouncedSearchMake, debouncedSearchModel, debouncedSearchPostcode, debouncedPriceFrom, debouncedPriceTo]);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-6 gap-3">
      <RegInput value={searchVrm} onChange={setSearchVrm} />
      <TextInput label={t("Name")} placeholder={t("Search by name...")} value={searchName} onChange={setSearchName} />
      <TextInput label={t("Make")} placeholder={t("Search by make...")} value={searchMake} onChange={setSearchMake} />
      <TextInput label={t("Model")} placeholder={t("Search by model...")} value={searchModel} onChange={setSearchModel} />
      <PostcodeInput value={searchPostcode} onChange={setSearchPostcode} />
      <PriceRangeInput from={priceFrom} to={priceTo} onFromChange={setPriceFrom} onToChange={setPriceTo} />
      {/* Price Range */}
      
      {/* Region */}
      {/* <div className="w-40">
        <label className="block text-xs font-medium text-gray-500 mb-1">Region</label>
        <select
          value={region}
          onChange={(e) => setRegion(e.target.value)}
          className="w-full rounded-md border border-gray-300 py-1.5 px-2 text-sm shadow-sm focus:border-primary-500 focus:ring-primary-500"
        >
          <option value="">All Regions</option>
          <option value="East Anglia">East Anglia</option>
          <option value="East Midlands">East Midlands</option>
          <option value="London">London</option>
          <option value="North East">North East</option>
          <option value="North West">North West</option>
          <option value="Northern Ireland">Northern Ireland</option>
          <option value="Scotland">Scotland</option>
          <option value="South East">South East</option>
          <option value="South West">South West</option>
          <option value="Wales">Wales</option>
          <option value="West Midlands">West Midlands</option>
          <option value="Yorkshire">Yorkshire</option>
        </select>
      </div> */}
      {/* Sort By */}
      {/* <div className="w-44">
        <label className="block text-xs font-medium text-gray-500 mb-1">Sort By</label>
        <select
          value={sortBy}
          onChange={(e) => setSortBy(e.target.value)}
          className="w-full rounded-md border border-gray-300 py-1.5 px-2 text-sm shadow-sm focus:border-primary-500 focus:ring-primary-500"
        >
          <option value="">Default</option>
          <option value="age_oldest">Age: Oldest First</option>
          <option value="age_newest">Age: Newest First</option>
          <option value="price_high">Price: High to Low</option>
          <option value="price_low">Price: Low to High</option>
          <option value="region_asc">Region: A–Z</option>
          <option value="region_desc">Region: Z–A</option>
        </select>
      </div>
      {(searchVrm || searchName || searchMake || searchModel || priceFrom || priceTo || region || sortBy) && (
        <button
          type="button"
          onClick={() => { setSearchVrm(""); setSearchName(""); setSearchMake(""); setSearchModel(""); setPriceFrom(""); setPriceTo(""); setRegion(""); setSortBy(""); }}
          className="rounded-md border border-gray-300 bg-white px-3 py-1.5 text-xs font-medium text-gray-600 hover:bg-gray-50 transition-colors"
        >
          Clear
        </button>
      )} */}
    </div>
  )
}

function RegInput({ value, onChange }: { value: string; onChange: (value: string) => void }) {
  const { t } = useTranslation("leads");
  return (
    <div>
      <label className="block text-xs font-medium text-gray-500 mb-1">{t("Registration")}</label>
      <div className="flex items-stretch">
        <div className="flex items-center justify-center w-8 rounded-l-md bg-yellow-400 border-2 border-yellow-500 border-r-0">
          <span className="text-[8px] font-black text-blue-900 leading-none">GB</span>
        </div>
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value.toUpperCase())}
          placeholder="REG"
          className="flex-1 min-w-0 rounded-r-md border-2 border-yellow-400 bg-yellow-50 px-2.5 py-1.5 text-sm font-bold text-gray-900 uppercase tracking-widest placeholder:text-gray-400 placeholder:font-normal placeholder:tracking-normal placeholder:normal-case focus:border-yellow-500 focus:ring-yellow-500"
        />
      </div>
    </div>
  )
}

function PostcodeInput({ value, onChange }: { value: string; onChange: (value: string) => void }) {
  const { t } = useTranslation("leads");
  return (
    <div>
      <label className="block text-xs font-medium text-gray-500 mb-1">{t("Postcode")}</label>
      <div className="relative">
        <MapPinIcon className="absolute left-2.5 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value.toUpperCase())}
          placeholder={t("e.g. BS, BA31")}
          title={t("Matches the start of the collection postcode. Separate multiple areas with a comma.")}
          className="w-full rounded-md border border-gray-300 pl-8 pr-3 py-1.5 text-sm uppercase shadow-sm placeholder:normal-case focus:border-primary-500 focus:ring-primary-500"
        />
      </div>
    </div>
  )
}

function TextInput({ label, placeholder, value, onChange }: { label: string; placeholder: string; value: string; onChange: (value: string) => void }) {
  return (
    <div>
      <label className="block text-xs font-medium text-gray-500 mb-1">{label}</label>
      <div className="relative">
        <MagnifyingGlassIcon className="absolute left-2.5 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="w-full rounded-md border border-gray-300 pl-8 pr-3 py-1.5 text-sm shadow-sm focus:border-primary-500 focus:ring-primary-500"
        />
      </div>
    </div>
  )
}

function PriceRangeInput({ from, to, onFromChange, onToChange }: { from: string; to: string; onFromChange: (value: string) => void; onToChange: (value: string) => void }) {
  const { t } = useTranslation("leads");
  return (
    <div className="flex items-center gap-2">
      <div>
        <label className="block text-xs font-medium text-gray-500 mb-1">{t("Price From")}</label>
        <div className="relative">
          <span className="absolute left-2 top-1/2 -translate-y-1/2 text-xs text-gray-400">£</span>
          <input
            type="number"
            value={from}
            onChange={(e) => onFromChange(e.target.value)}
            placeholder={t("Min")}
            min="0"
            className="w-full rounded-md border border-gray-300 pl-5 pr-2 py-1.5 text-sm shadow-sm focus:border-primary-500 focus:ring-primary-500"
          />
        </div>
      </div>
      <span className="text-gray-400 text-xs mt-5">–</span>
      <div>
        <label className="block text-xs font-medium text-gray-500 mb-1">{t("Price To")}</label>
        <div className="relative">
          <span className="absolute left-2 top-1/2 -translate-y-1/2 text-xs text-gray-400">£</span>
          <input
            type="number"
            value={to}
            onChange={(e) => onToChange(e.target.value)}
            placeholder={t("Max")}
            min="0"
            className="w-full rounded-md border border-gray-300 pl-5 pr-2 py-1.5 text-sm shadow-sm focus:border-primary-500 focus:ring-primary-500"
          />
        </div>
      </div>
    </div>
  )
}